import _ from 'lodash'
import type {CssValue} from '../../constants'
import {deserializeUnit, serializeUnit} from '../utils/unit'
import type {Crop} from './types'

const CROP_UNIT_TYPE = 'px'
const VALID_UNIT_TYPES_SET = new Set([CROP_UNIT_TYPE])

const serializePxUnit = (value: number): string | undefined =>
    serializeUnit({value, type: CROP_UNIT_TYPE}, VALID_UNIT_TYPES_SET)

const deserializePxUnit = _.partial(deserializeUnit<string>, _, VALID_UNIT_TYPES_SET)

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val) || Object.keys(val).length !== 4) {
        return undefined
    }

    const {x, y, width, height} = val

    if (!_.isNumber(x) || !_.isNumber(y) || !_.isNumber(width) || !_.isNumber(height)) {
        return undefined
    }

    const xString = serializePxUnit(x)
    const yString = serializePxUnit(y)
    const widthString = serializePxUnit(width)
    const heightString = serializePxUnit(height)

    return `${xString} ${yString} ${widthString} ${heightString}`
}

const deserialize = (rule: CssValue): Crop | undefined => {
    const props = rule.split(' ')

    if (props.length !== 4) {
        return undefined
    }

    const [xString, yString, widthString, heightString] = props

    if (!xString || !yString || !widthString || !heightString) {
        return undefined
    }

    const x = deserializePxUnit(xString)
    const y = deserializePxUnit(yString)
    const width = deserializePxUnit(widthString)
    const height = deserializePxUnit(heightString)

    if (!x || !y || !width || !height) {
        return undefined
    }

    return {
        x: x.value,
        y: y.value,
        width: width.value,
        height: height.value
    }
}

export default {
    serialize,
    deserialize
}
